// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"de5b2a68","106":"1983b48a","253":"1c1f8b13","702":"013d5325","787":"a7829cbb","909":"4aaf14ef","994":"90fe4534"}[chunkId] + ".css";
};